import { Container } from "@mui/material";
import { CasUserContext, useCasUserContext } from "../../services/casUserContext";
import { useContext, useEffect, useState} from 'react';
import { array } from "yup";
import { useNavigate } from "react-router-dom";
import { UnauthorizedPage } from "../Error/ErrorUnauthorized";
import UsuarioService from "../../services/UsuarioService";
import { BusquedaPersonal } from "../../componentes/Proyectos/BusquedaPersonal";

const usuarioService = new UsuarioService();

export const ReportePorPersonaPage: React.FC<{}> = () =>{
    //const casUserContext = useContext(CasUserContext);
    const casUserContext = useCasUserContext();
    const userData = casUserContext.userData;
    const roles = casUserContext.userData.roles;
    const [auth,setAuth] = useState(true);

    //Seccion Carga
    useEffect(() => {
        const flag = usuarioService.authorizedByRol(142,roles) || usuarioService.authorizedByRol(151,roles);
        setAuth(flag);
    },[userData]);

    return(
        <Container maxWidth="lg" sx={{mt:4}}>
            {auth ? 
                <BusquedaPersonal />
                :
                <UnauthorizedPage />
            }
        </Container>
    );
}